module.exports = __webpack_public_path__ + "static/media/currency_rupee.08b33226.svg";